import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { useEffect, useState } from "react";

/**
 * Compose-and-send dialog used whenever a task escalates to admins, so the
 * sender can always add context instead of firing a silent, generic ping.
 */
const NotifyAdminDialog = ({
  open,
  onClose,
  onSubmit,
  defaultMessage = "",
  loading = false,
  title = "Notify admin",
}) => {
  const [message, setMessage] = useState(defaultMessage);

  useEffect(() => {
    if (open) setMessage(defaultMessage);
  }, [open, defaultMessage]);

  const handleSubmit = () => {
    if (!message.trim()) return;
    onSubmit?.(message.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pr: 6 }}>
        <NotificationsActiveOutlinedIcon color="warning" />
        {title}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <p className="text-sm text-app-text-secondary mb-3">
          This sends an immediate notification to your organization's admins with the message below.
        </p>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={4}
          placeholder="Explain what admins need to know..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="warning"
          onClick={handleSubmit}
          disabled={!message.trim() || loading}
        >
          {loading ? "Sending..." : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotifyAdminDialog;
